
export default {//改变state里定义的变量的方法,调用方法是this.$store.commit('方法名','要改变的数据')
    setUserInfo (state, obj) {
        state.userInfo = obj;
    },
    setIsLogin (state, boolean) {
        state.isLogin = boolean;
    },
    setShowLogin (state, boolean) {
        state.show_login_compoments = boolean;
    },
    setShowUserInfo (state, boolean) {
        state.show_userinfo_compoments = boolean;
    },
    setShowCodeExchange (state, boolean) {
        state.show_code_exchange_compoments = boolean;
    },
    setShowBindPhone (state, boolean) {
        state.show_bindphone_compoments = boolean;
    },
    setShowAttenDance (state, boolean) {
        state.show_attendance_compoments = boolean;
    },
    setShowOpen (state, boolean) {
        state.show_open_compoments = boolean;
    },
    setShowQuestion (state, boolean) {
        state.show_question_compoments = boolean;
    },
    setToastVip (state, boolean) {
        state.show_toast_vip = boolean;
    },
    setVideoType (state, type) {
        state.video_type = type;
    },
    setInviteCode (state, boolean) {
        state.shou_invite_code = boolean;
    },
    setTipsCom (state, boolean) {
        state.shou_tips_com = boolean;
    },
    setChooseTips (state, arr) {
        state.hav_choose_tips = arr;
    },
    setActiveTip (state, name) {
        state.active_tip = name;
    },
    setToastNotice (state, boolean) {
        state.show_toast_notice = boolean;
    },
    showKehuTip (state, boolean){
        state.show_kehu_tip = boolean;
    },
    showVipTime (state, boolean){
        state.show_vip_time = boolean;
    },
    setisPayPopShow(state, data) {
        state.isPayPopShow = data;
    },
    setUpyouDetail(state, boolean){
        state.upYouDetail = boolean;
    },
    setShow_Continue(state, data) {
        state.show_Continue = data;
    },
    setRevisionShow(state, data) {
        state.RevisionShow = data;
    },
    setRevisionWin(state, data) {
        state.RevisionWin = data;
    },
    setVideoTipBoxShow(state, data) {
        state.videoTipBoxShow = data;
    },

    setFisYouh(state, boolean){
        state.fisYouh = boolean;
    },
    setSecYouh(state, boolean){
        state.secYouh = boolean;
    },
    setHeader_r_show(state, data) {
        state.header_r_show = data;
    },
    setVipYouhuiHeaderShow(state, data) {
		state.vip_youhui_header_show = data;
	},
    //恭喜你成为xxx弹窗
    setVipCongratulationsShow(state, data) {
		state.vip_congratulations_show = data;
	},

    //技术维护弹窗
    setTechnical_Show(state, data) {
        state.Technical_Show = data;
    },
}
